import React from 'react'
import { FormattedMessage } from 'react-intl'
import LabelledField from './LabelledField'
import styles from './CheckBox.css'

const Switch = ({ on }) => {
  return (
    <div className={[styles.switch, on ? styles.on : styles.off].join(' ')}>
      <div>
        <span>{on ? 'ON' : 'OFF'}</span>
      </div>
    </div>
  )
}

const CheckBox = props => {
  return (
    <LabelledField {...props}>
      <div className={styles.checkbox}>
        <div className={styles.children}>
          <Switch on={props.input.value} />
        </div>
        <input
          className={[styles.children, styles.input].join(' ')}
          {...props.input}
          {...props.inputProps}
          type="checkbox"
          checked={props.input.value}
        />
        {!!props.input.value && props.on_placeholder ? (
          <FormattedMessage id={props.on_placeholder} />
        ) : null}
        {!props.input.value && props.off_placeholder ? (
          <FormattedMessage id={props.off_placeholder} />
        ) : null}
      </div>
    </LabelledField>
  )
}

export default CheckBox
